import useFetch from '../hooks/useFetch'
// import { objectToQueryString } from '../utils';
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchEventBlueprints = async () => {
    return apiWrapper({
      fetch,
      url: `builder/eventBlueprints`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchEventBlueprint = async (eventBlueprintId) => {
    return apiWrapper({
      fetch,
      url: `builder/eventBlueprint?eventBlueprintId=${eventBlueprintId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchSessionBlueprints = async () => {
    return apiWrapper({
      fetch,
      url: `builder/sessionBlueprints`,
      options: {
        method: 'GET'
      }
    });
  }

  const updateEventBlueprint = async (eventBlueprintData) => {
    return apiWrapper({
      fetch,
      url: `builder/eventBlueprint/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: eventBlueprintData })
      }
    });
  }

  const fetchModuleBlueprints = async () => {
    return apiWrapper({
      fetch,
      url: `builder/moduleBlueprints`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchModuleBlueprint = async (moduleBlueprintId) => {
    return apiWrapper({
      fetch,
      url: `builder/moduleBlueprint?moduleBlueprintId=${moduleBlueprintId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const updateModuleBlueprint = async (moduleBlueprintData) => {
    return apiWrapper({
      fetch,
      url: `builder/moduleBlueprint/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: moduleBlueprintData })
      }
    });
  }

  const fetchProducts = async () => {
    return apiWrapper({
      fetch,
      url: `builder/products`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchEventBlueprint,
    fetchEventBlueprints,
    fetchSessionBlueprints,
    updateEventBlueprint,
    fetchModuleBlueprint,
    fetchModuleBlueprints,
    updateModuleBlueprint,
    fetchProducts
  }
}